{
  "longPressMessage": "Lang indrukken voor voorvertoning"
}
